import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const SSOLinkUserPage = lazy(() => import('./SSOLinkUserPage'))

class SSOLinkUserPageWebComponent extends ReactWebComponent {
  override render() {
    return (
      <PageRoot>
        <SSOLinkUserPage />
      </PageRoot>
    )
  }
}

customElements.define('sso-link-user-page', SSOLinkUserPageWebComponent)
